import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "searchResultsOverlay" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  preserveAspectRatio: "xMinYMid",
  "aria-hidden": "true",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M315.25 20.25V31H326v1.5h-10.75v10.75h-1.5V32.5H303V31h10.75V20.25h1.5z",
      transform: "translate(-305 -79) translate(0 56) rotate(45 314.5 31.75)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "searchResultsHeader" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "updateSearch" }
const _hoisted_8 = { class: "searchResultsFilterTitle" }
const _hoisted_9 = { class: "searchResultsInputInner" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "searchResultsFilterInput" }, null, -1)
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 18",
  preserveAspectRatio: "xMinYMid",
  "aria-hidden": "true",
  role: "img",
  fill: "#1A1347"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M315.25 20.25V31H326v1.5h-10.75v10.75h-1.5V32.5H303V31h10.75V20.25h1.5z",
      transform: "translate(-305 -79) translate(0 56) rotate(45 314.5 31.75)"
    })
  ])
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["disabled", "aria-label"]
const _hoisted_16 = { class: "searchResultsContentWrapper" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = {
  key: 1,
  class: "error"
}
const _hoisted_19 = {
  key: 2,
  class: "resultItems"
}
const _hoisted_20 = {
  key: 3,
  class: "loading"
}
const _hoisted_21 = {
  key: 4,
  class: "noResults"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "noResultsIcon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    role: "img",
    "aria-hidden": "true",
    viewBox: "0 0 55 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M54.23 83V34.22C54.2004 31.3975 53.0869 28.6944 51.12 26.67C50.0867 25.5519 49.4872 24.1013 49.4299 22.58L48.26 0H36.97L35.7999 22.58C35.7507 24.1012 35.1542 25.5534 34.12 26.67C32.1446 28.6978 31.0272 31.4092 31 34.24V45.24H0V46.74C0 55.62 7.61 62.94 17.25 63.63V80H10.7V83H26.7V80H20.1899V63.63C24.0928 63.3755 27.83 61.9579 30.9199 59.56V83H54.23ZM33.97 80V75.87H51.23V80H33.97ZM33.97 34.26C33.999 32.2016 34.8106 30.2315 36.24 28.75C37.7811 27.1217 38.6799 24.9901 38.7699 22.75L39.7699 3.02002H45.36L46.36 22.75C46.4509 24.988 47.3456 27.1183 48.88 28.75C50.3109 30.2183 51.1234 32.1799 51.1499 34.23V72.86H33.8899V56.6C36.1475 53.8083 37.3857 50.3303 37.3999 46.74V45.24H33.8899L33.97 34.26ZM18.7 60.69C10.59 60.69 3.88992 55.23 3.03992 48.24H34.36C34.279 48.9177 34.1385 49.587 33.9399 50.24C33.355 52.1965 32.3286 53.9927 30.9399 55.49C29.3691 57.1546 27.4707 58.476 25.3641 59.371C23.2576 60.2659 20.9886 60.715 18.7 60.69V60.69Z",
      fill: "#00341C"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultsIndicator = _resolveComponent("ResultsIndicator")!
  const _component_ResultItemsContainer = _resolveComponent("ResultItemsContainer")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_RenderSearchResults = _resolveComponent("RenderSearchResults")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "closeResults",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeResults && _ctx.closeResults(...args))),
        "aria-label": _ctx.$t('Web.Containers.CloseSearchOverlay')
      }, _hoisted_4, 8, _hoisted_2)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: _ctx.siteLogo,
          alt: ""
        }, null, 8, _hoisted_6),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Web.Components.SearchResultsTitle")), 1)
      ]),
      _createVNode(_component_RenderSearchResults, {
        parentid: _ctx.searchRoot,
        keyword: _ctx.keywordInput,
        page: _ctx.currentActivePage,
        pagesize: _ctx.pageSize,
        personalisationGroupIds: _ctx.personalisationGroupIds,
        endPoint: _ctx.apiendpoint,
        language: _ctx.language,
        onSearchChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resourcesChanged($event, _ctx.pageSize)))
      }, {
        search: _withCtx(({ searchResult, searchLoading, searchError }) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Web.Components.SearchResultsCTA")), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["searchResultsFilterInner", _ctx.keywordError && 'searchError'])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  id: "searchResultsFilterInput",
                  class: "searchResultsInput",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args)), ["prevent"]), ["enter"])),
                  type: "search",
                  placeholder: _ctx.$t('Web.Containers.SearchLabel'),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keyword) = $event)),
                  autocomplete: "off"
                }, null, 40, _hoisted_11), [
                  [_vModelText, _ctx.keyword]
                ]),
                (_ctx.keyword.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "clearButton",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearKeyword && _ctx.clearKeyword(...args))),
                      "aria-label": _ctx.$t('Web.Containers.ClearKeyword')
                    }, _hoisted_14, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "searchButton",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args))),
                disabled: !_ctx.keywordLengthOK(),
                "aria-label": _ctx.$t('Web.Containers.SubmitSearch')
              }, _toDisplayString(_ctx.$t("Web.Containers.Search")), 9, _hoisted_15)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (searchResult.totalResults > 0)
                ? (_openBlock(), _createBlock(_component_ResultsIndicator, {
                    key: 0,
                    first: _ctx.firstPage(_ctx.currentActivePage, _ctx.pageSize),
                    term: _ctx.keywordInput,
                    last: _ctx.lastPage(searchResult.totalResults, _ctx.pageSize),
                    total: searchResult.totalResults,
                    indexTitle: _ctx.title
                  }, null, 8, ["first", "term", "last", "total", "indexTitle"]))
                : _createCommentVNode("", true),
              searchError
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("Web.Containers.LoadingResourceError")), 1))
                : _createCommentVNode("", true),
              (
                  !searchError &&
                    searchResult.results !== undefined &&
                    searchResult.results.length > 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_ResultItemsContainer, {
                      results: searchResult,
                      resultType: _ctx.resultType
                    }, null, 8, ["results", "resultType"])
                  ]))
                : _createCommentVNode("", true),
              (searchLoading && !searchError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("Web.Containers.LoadingResults")), 1)
                  ]))
                : _createCommentVNode("", true),
              (
                  !searchLoading &&
                    !searchError &&
                    (searchResult === undefined ||
                      searchResult.results === undefined ||
                      searchResult.results.length === 0)
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("Web.Components.SearchResultsNoResults")), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("Web.Components.SearchResultsTryAnotherSearch")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (
              !searchError &&
                searchResult.results !== undefined &&
                searchResult.results.length > 0
            )
            ? (_openBlock(), _createBlock(_component_Pagination, {
                key: 0,
                onPageChanged: _ctx.paginationClick
              }, null, 8, ["onPageChanged"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["parentid", "keyword", "page", "pagesize", "personalisationGroupIds", "endPoint", "language"])
    ])
  ]))
}